import _ from 'underscore'
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import AppUtils from '../../../utils/AppUtils'
import AppConstants from '../../../utils/AppConstants'
import ColumnsProvider from '../../../utils/ColumnsProvider'
import ExecutionForm from '../../../components/forms/ExecutionForm'
import Popup from '../../../components/elements/Popup'
import Confirm from '../../../components/elements/Confirm'
import Details from '../../../components/elements/Details'
import Table from '../../../components/elements/Table'
import Dismissible from '../../../components/elements/Dismissible'
import Form from '../../../components/elements/Form'
import LocationSelect from '../../../components/elements/forms/LocationSelect'

import Types from '../../../actions/Types'
import PostPhase1Action from '../../../actions/executions/PostPhase1Action'
import PostPhase2Action from '../../../actions/executions/PostPhase2Action'
import DeleteAction from '../../../actions/executions/DeleteAction'
import ClearErrorAction from '../../../actions/app/ClearErrorAction'

class CreateExecutionPopup extends React.Component {

  constructor(props) {

    // Properties
    super(props)

    // State
    this.state = {
      phase: 1,
      submit1: null,
      data2: null,
      isCancelling2: false,
      selected2: null
    }

    // Bind events
    this.submit1 = this.submit1.bind(this)
    this.submit2 = this.submit2.bind(this)
    this.cancel2 = this.cancel2.bind(this)
    this.cancel2Confirm = this.cancel2Confirm.bind(this)
    this.onSelectLocation = this.onSelectLocation.bind(this)
    this.onChangeStatusOrRemark = this.onChangeStatusOrRemark.bind(this)
    this.onSubmit1 = this.onSubmit1.bind(this)
  }

  componentDidUpdate(prevProps, prevState) {
    // On phase 1 success, go to phase 2
    if (
      prevProps.isSaving
      &&
      !this.props.isSaving
      &&
      !this.props.saveError
      &&
      this.props.phase === 1
    ) {
      this.setState({
        phase: 2,
        selected2: _.first(this.props.data2.locations).location.id,
        data2: this.props.data2
      })
    }

    // On phase 2 success, close popup
    if (
      prevProps.isSaving
      &&
      !this.props.isSaving
      &&
      !this.props.saveError
      &&
      this.props.phase === 2
    ) {
      AppUtils.setStatus(AppConstants.STATUS.TYPE.SUCCESS, 'Maintenance effectuée avec succès.')
      this.props.onClose(this.state.data2.id)
    }

    // On phase 2 cancellation, close popup
    if (
      prevProps.isDeleting
      &&
      !this.props.isDeleting
    ) {
      AppUtils.setStatus(
        this.props.deleteError
          ? AppConstants.STATUS.TYPE.FAILURE
          : AppConstants.STATUS.TYPE.WARNING,
        this.props.deleteError
          ? AppUtils.errorToText(this.props.deleteError)
          : 'Maintenance annulée.'
      )
      this.props.onClose(null)
    }
  }

  submit1() {
    if (_.isFunction(this.state.submit1)) {
      this.state.submit1()
    }
  }

  submit2() {
    this.props.postPhase2(this.state.data2)
  }

  cancel2() {
    this.setState({
      isCancelling2: true
    })
  }

  cancel2Confirm(proceed) {
    this.setState({
      isCancelling2: false
    })
    if (proceed) {
      this.props.delete(this.state.data2.id)
    }
  }

  onSelectLocation(selected2) {
    this.setState({ selected2 })
  }

  onChangeStatusOrRemark(locationId, itemId, what) {
    return (statusOrRemark) => {
      this.setState((prevState, props) => ({
        data2: _.extend(
          {},
          prevState.data2,
          {
            locations: _.map(
              prevState.data2.locations,
              (location) => (location.location.id === locationId
                ? _.extend(
                    {},
                    location,
                    {
                      items: _.map(
                        location.items,
                        (item) => (item.item.id === itemId
                          ? _.extend(
                              {},
                              _.pick(item, 'item'),
                              what === 'status'
                                ? {
                                    status: statusOrRemark
                                  }
                                : _.pick(item, 'status'),
                              (
                                what === 'status'
                                &&
                                statusOrRemark === AppConstants.PRODUCT.ITEM.MAINTENANCE.STATUS.FAILURE
                              )
                                ? _.extend(
                                    {
                                      remark: ''
                                    },
                                    _.pick(item, 'remark')
                                  )
                                : {},
                              (
                                what === 'remark'
                                &&
                                item.status === AppConstants.PRODUCT.ITEM.MAINTENANCE.STATUS.FAILURE
                              )
                                ? {
                                    remark: statusOrRemark
                                  }
                                : {},
                            )
                          : item
                        )
                      )
                    }
                  )
                : location
              )
            )
          }
        )
      }))
    }
  }

  onSubmit1(data) {
    this.props.postPhase1(data)
  }

  render() {
    const locationsList = this.state.phase === 2
      ? (
          _.map(
            this.state.data2.locations,
            (location) => {
              const successCount = _.size(_.filter(
                location.items,
                (item) => (item.status === AppConstants.PRODUCT.ITEM.MAINTENANCE.STATUS.SUCCESS)
              ))
              const failureCount = _.size(_.filter(
                location.items,
                (item) => (item.status === AppConstants.PRODUCT.ITEM.MAINTENANCE.STATUS.FAILURE)
              ))
              const noneCount = _.size(_.filter(
                location.items,
                (item) => (item.status === AppConstants.PRODUCT.ITEM.MAINTENANCE.STATUS.NONE)
              ))
              return _.extend(
                {},
                location.location,
                {
                  details: _.union(
                    successCount > 0
                      ? [{
                          icon: Details.ICON.SUCCESS,
                          text: `Succès pour ${successCount} pièce${successCount > 1 ? 's' : ''}`
                        }]
                      : [],
                    failureCount > 0
                      ? [{
                          icon: Details.ICON.FAILURE,
                          text: `Echec pour ${failureCount} pièce${failureCount > 1 ? 's' : ''}`
                        }]
                      : [],
                    noneCount > 0
                      ? [{
                          icon: Details.ICON.WARNING,
                          text: `Pas exécutée pour ${noneCount} pièce${noneCount > 1 ? 's' : ''}`
                        }]
                      : [],
                  )
                }
              )
            }
          )
        )
      : null
    const selectedLocation = this.state.phase === 2 && this.state.selected2
      ? _.find(
          this.state.data2.locations,
          (location) => (location.location.id === this.state.selected2)
        )
      : null
    const itemsList = !_.isNull(selectedLocation)
      ? (
          _.map(
            selectedLocation.items,
            (item) => (
              _.extend(
                {},
                _.pick(item, 'status', 'remark'),
                _.pick(item.item, 'compartment'),
                {
                  number: (
                    this.props.maintenance
                    &&
                    this.props.maintenance.product
                    &&
                    !_.isNull(this.props.maintenance.product.prefix)
                      ? `${this.props.maintenance.product.prefix}${item.item.number}`
                      : null
                  )
                },
                {
                  location: selectedLocation.location.id,
                  item: item.item.id
                }
              )
            )
          )
        )
      : null
    return (
      this.state.phase === 1
        ? <Popup
            header="Effectuer une maintenance (base)"
            body={
              <ExecutionForm
                data={undefined}
                maintenance={this.props.maintenance}
                onSubmit={this.onSubmit1}
                onClearError={this.props.clearError}
                isLoading={false}
                isSaving={this.props.isSaving}
                registerSubmit={(submit1) => { this.setState({ submit1 })}}
                error={this.props.saveError}
              />
            }
            footer={[
              {
                type: Popup.BUTTONTYPE.CLOSE,
                title: 'Annuler',
                color: 'red',
                icon: 'close',
                basic: true,
                onClick: () => this.props.onClose(null)
              },
              {
                type: Popup.BUTTONTYPE.SUBMIT,
                title: 'Démarrer',
                color: 'green',
                icon: 'play',
                onClick: this.submit1
              }
            ]}
            isLoading={false}
            isSaving={this.props.isSaving}
          />
        : <React.Fragment>
            <Popup
              header="Effectuer une maintenance (détails)"
              body={
                <React.Fragment>
                  {
                    this.props.saveError
                      ? <Dismissible
                          header={AppUtils.errorToTitle(this.props.saveError)}
                          content={AppUtils.errorToText(this.props.saveError)}
                          color='red'
                          onDismiss={this.props.clearError}
                        />
                      : null
                  }
                  <div style={{
                    height: '70vh',
                    display: 'flex',
                    flexDirection: 'column'
                  }}>
                    <div style={{
                      flex: '0 0 auto'
                    }}>
                      <Form
                        onSubmit={() => {}}
                        loading={this.props.isSaving}
                      >
                        <LocationSelect
                          label='Emplacement'
                          loading={false}
                          options={locationsList}
                          selected={this.state.selected2}
                          onChange={this.onSelectLocation}
                        />
                      </Form>
                    </div>
                    <Table
                      columns={_.union(
                        // N°
                        this.props.maintenance
                        &&
                        this.props.maintenance.product
                        &&
                        !_.isNull(this.props.maintenance.product.prefix)
                          ? [ ColumnsProvider.itemNumberFull ]
                          : [],
                        [
                          // Compartiment
                          ColumnsProvider.itemCompartmentBasic,
                          // Saisie
                          ColumnsProvider.executionItemInput(this.onChangeStatusOrRemark),
                          // Status
                          ColumnsProvider.executionItemStatus
                        ]
                      )}
                      data={itemsList}
                      error={null}
                      isLoading={false}
                      emptyMessage="Aucun matériel dans cet emplacement."
                    />
                  </div>
                </React.Fragment>
              }
              footer={[
                {
                  type: Popup.BUTTONTYPE.CLOSE,
                  title: 'Arrêter',
                  color: 'red',
                  icon: 'close',
                  basic: true,
                  onClick: this.cancel2
                },
                {
                  type: Popup.BUTTONTYPE.SUBMIT,
                  title: 'Terminer',
                  color: 'green',
                  icon: 'checkmark',
                  onClick: this.submit2
                }
              ]}
              size='fullscreen'
              isLoading={false}
              isSaving={this.props.isSaving || this.props.isDeleting}
            />
            {
              this.state.isCancelling2
                ? <Confirm
                    header="Arrêt de la maintenance"
                    body="Êtes-vous sûr de vouloir arrêter la maintenance en cours ? Toutes les informations saisies seront perdues."
                    confirmText="Arrêter"
                    confirmColor='red'
                    confirmIcon='trash'
                    callback={this.cancel2Confirm}
                  />
                : null
            }
          </React.Fragment>
    )
  }
}

CreateExecutionPopup.propTypes = {
  // Properties
  maintenance: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,

  // Redux State
  phase: PropTypes.number,
  isSaving: PropTypes.bool.isRequired,
  saveError: PropTypes.object,
  data2: PropTypes.object,
  isDeleting: PropTypes.bool.isRequired,
  deleteError: PropTypes.object,

  // Redux Actions
  postPhase1: PropTypes.func.isRequired,
  postPhase2: PropTypes.func.isRequired,
  delete: PropTypes.func.isRequired,
  clearError: PropTypes.func.isRequired
}

export default connect(
  (state) => ({
    phase: state.entities.executions.post.phase,
    isSaving: state.entities.executions.post.isFetching,
    saveError: state.entities.executions.post.error,
    data2: state.entities.executions.post.data,
    isDeleting: state.entities.executions.delete.isFetching,
    deleteError: state.entities.executions.delete.error
  }),
  (dispatch) => ({
    postPhase1: (data) => (dispatch(PostPhase1Action({ data }))),
    postPhase2: (data) => (dispatch(PostPhase2Action({ data }))),
    delete: (id) => (dispatch(DeleteAction({ id }))),
    clearError: () => (dispatch(ClearErrorAction(Types.EXECUTIONS.POST)))
  })
)(CreateExecutionPopup)



// WEBPACK FOOTER //
// ./src/containers/popups/executions/CreateExecutionPopup.js